<template>
  <div>
    <div class="affnews-wrapper mx-auto hidden-md-and-up">
      <div class="top-content">
        <!--      <div class="top-left-corner-label"></div>-->
        <v-row no-gutters class="top-left-label">ভাগ্য এ্যাফিলিয়েট প্রোগ্রাম</v-row>
        <v-row no-gutters class="top-full-row-label ">
          <div class="full-width">
            টাকা আয় করুন
          </div>
          <div class="full-width">
            ভাগ্য - এর সাথে!!
          </div>
        </v-row>
        <div class="imgContains">
          <v-img class="ladies" contain src="/static/image/affiliate/ladies.png" :aspect-ratio="540 / 360"></v-img>
          <img class="coins" src="/static/image/affiliate/affNewsCoins.png" />
          <img class="backLight" src="/static/image/affiliate/backLight.png" />
        </div>
        <!--      <img src="/static/image/affiliate/ladies.png" />-->
        <!--      <v-row class="top-full-row-label "></v-row>-->
      </div>
      <div class="bottom-content">
        <v-row>
          <v-col class="d-flex justify-center">
            <v-col cols="8">
              <v-btn @click="gotoForm" class="full-width chip-text">
                <span class="contact-finger-icon">👇</span>
                রেজিস্ট্রেশন করতে ক্লিক করুন
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
        <div class="tnc">
          <h3 style="color: #4D5A30;" class="text-center y-padding">{{ $t(`affPromo.tittle1`) }}</h3>
          <h3 style="color: #4D5A30;" class="text-center y-padding">{{ $t(`affPromo.tittle2`) }}</h3>
          <!--       -->
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tncQ`) }}</span>
          </p>
        </div>
        <div class="affNews-info">
          <ol>
            <li>{{ $t(`affPromo.tnc1`) }}</li>
            <li>{{ $t(`affPromo.tnc2`) }}</li>
            <li>{{ $t(`affPromo.tnc3`) }}</li>
            <li>{{ $t(`affPromo.tnc4`) }}</li>
          </ol>
        </div>
        <div class="tnc-2nd-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle`) }}</span>
          </p>
          <p v-html="$t(`affPromo.tnc-2nd-c1`)"></p>
          <p>{{ $t(`affPromo.tnc-2nd-c2`) }}</p>
          <p>{{ $t(`affPromo.tnc-2nd-c3`) }}</p>
        </div>

        <div class="tnc-3rd-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle2`) }}</span>
          </p>
          <table>
            <thead>
              <tr>
                <td>{{ $t(`affPromo.tnc-header1`) }}</td>
                <td>{{ $t(`affPromo.tnc-header2`) }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t(`affPromo.tnc-r1c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r1c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-r2c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r2c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-r3c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r3c2`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tnc-4th-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle3`) }}</span>
          </p>
          <table>
            <tbody>
              <tr>
                <td>{{ $t(`affPromo.tnc-t2r1c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-t2r1c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-t2r2c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-t2r2c2`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tnc-5th-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle4`) }}</span>
          </p>
          <div class="affNews-info">
            <ol>
              <li>{{ $t(`affPromo.tnc-5thc1`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc2`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc3`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc4`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc5`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc6`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc7`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc8`) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="desktopNews-wrapper  hidden-sm-and-down">
      <div class="top-content">
        <!--      <div class="top-left-corner-label"></div>-->
        <v-row no-gutters class="top-left-label">ভাগ্য এ্যাফিলিয়েট প্রোগ্রাম</v-row>
        <v-row no-gutters class="top-full-row-label ">
          <div class="full-width">
            টাকা আয় করুন
          </div>
          <div class="full-width">
            ভাগ্য - এর সাথে!!
          </div>
        </v-row>
        <div>
          <img class="desktop-ladies" src="/static/image/affiliate/ladies.png" />
          <img class="desktop-coins" src="/static/image/affiliate/affNewsCoins.png" />
<!--          <img class="desktop-backLight" src="/static/image/affiliate/backLight.png" />-->

        </div>

        <v-row>
          <!--          <v-img  max-height="150" class="ladies" contain src="/static/image/affiliate/ladies.png" :aspect-ratio="540 / 360"></v-img>-->
        </v-row>
        <!--        <div class="imgContains">-->
        <!--          <v-img class="ladies" contain src="/static/image/affiliate/ladies.png" :aspect-ratio="540 / 360"></v-img>-->

        <!--          <img class="coins" src="/static/image/affiliate/affNewsCoins.png" />-->
        <!--          <img class="backLight" src="/static/image/affiliate/backLight.png" />-->
        <!--        </div>-->
        <!--      <img src="/static/image/affiliate/ladies.png" />-->
        <!--      <v-row class="top-full-row-label "></v-row>-->
      </div>
      <div class="bottom-content">
        <v-row class="">
          <v-col class="d-flex justify-center">
            <v-col cols="8">
              <v-btn @click="gotoForm" class="full-width chip-text">
                <span class="contact-finger-icon">👇</span>
                রেজিস্ট্রেশন করতে ক্লিক করুন
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
        <div class="tnc">
          <h3 style="color: #4D5A30;" class="text-center y-padding">{{ $t(`affPromo.tittle1`) }}</h3>
          <h3 style="color: #4D5A30;" class="text-center y-padding">{{ $t(`affPromo.tittle2`) }}</h3>
          <!--       -->

        </div>
        <div class="affNews-info">
          <p style="margin-bottom: 6px;margin-top: 16px;font-size: 25px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tncQ`) }}</span>
          </p>
          <ol>
            <li>{{ $t(`affPromo.tnc1`) }}</li>
            <li>{{ $t(`affPromo.tnc2`) }}</li>
            <li>{{ $t(`affPromo.tnc3`) }}</li>
            <li>{{ $t(`affPromo.tnc4`) }}</li>
          </ol>
        </div>

        <div class="tnc-2nd-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle`) }}</span>
          </p>
          <p v-html="$t(`affPromo.tnc-2nd-c1`)"></p>
          <p>{{ $t(`affPromo.tnc-2nd-c2`) }}</p>
          <p>{{ $t(`affPromo.tnc-2nd-c3`) }}</p>
        </div>

        <div class="tnc-3rd-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle2`) }}</span>
          </p>
          <table>
            <thead>
              <tr>
                <td>{{ $t(`affPromo.tnc-header1`) }}</td>
                <td>{{ $t(`affPromo.tnc-header2`) }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t(`affPromo.tnc-r1c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r1c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-r2c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r2c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-r3c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-r3c2`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tnc-4th-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle3`) }}</span>
          </p>
          <table>
            <tbody>
              <tr>
                <td>{{ $t(`affPromo.tnc-t2r1c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-t2r1c2`) }}</td>
              </tr>
              <tr>
                <td>{{ $t(`affPromo.tnc-t2r2c1`) }}</td>
                <td>{{ $t(`affPromo.tnc-t2r2c2`) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tnc-5th-div">
          <p style="margin-bottom: 6px;margin-top: 16px;">
            <span class="color-theme" style="font-weight: bolder">{{ $t(`affPromo.tnc-subtitle4`) }}</span>
          </p>
          <div class="affNews-info">
            <ol>
              <li>{{ $t(`affPromo.tnc-5thc1`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc2`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc3`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc4`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc5`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc6`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc7`) }}</li>
              <li>{{ $t(`affPromo.tnc-5thc8`) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { locale, uiHelper } from '@/util'

export default {
  name: 'promoNews',
  created() {
    this.metaTag()
  },
  methods: {
    gotoForm() {
      window.open('https://forms.gle/ifropRSBZNmpq97H8')
    },
    gotoWhatsapp() {
      window.open('http://wa.me/+60147746114')
    },
    metaTag() {
      uiHelper.setTitle(`${locale.getMessage('meta.promoNews_title')}`)
      uiHelper.setMetaTag('description', `${locale.getMessage('meta.promoNews_description')}`)
    }
  }
}
</script>

<style lang="scss">
//@font-face {
//  font-family: 'Li-Ador-Noirrit-A';
//  src: url('/static/font/Li_Ador_Noirrit.ttf');
//}
@font-face {
  font-family: 'Li-Ador-Noirrit-2';
  src: url('/static/font/Li_Ador_Noirrit_A_V2.ttf');
}

.color-theme {
  color: #4d5a30;
}

.y-padding {
  padding: 10px 0;
}

.chip-text {
  font-family: 'Li-Ador-Noirrit-2';
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  height: 55px !important;
  color: #ffffff !important;
  background: linear-gradient(92.5deg, #517500 1.84%, #80a923 96.78%) !important;
  border-radius: 30px !important;

  .contact-finger-icon {
    transform: rotate(-120deg);
    font-size: 1.5rem;
  }
}

.bottom-content {
  padding: 3% 3% 0% 3%;
  max-width: 599px;

  .contact-card {
    background: rgba(106, 145, 18, 0.5);
    border-radius: 15px;
    height: 95px;
  }

  .contact-card-title {
    font-family: 'Li-Ador-Noirrit-2';
    font-weight: 700;
    font-size: 1rem;
    line-height: 26px;
    padding: 10px;
  }

  .tnc {
    padding: 3% 3% 3% 5%;
    font-weight: 700;
    font-size: 25px;
  }

  .tnc1 {
    font-weight: 400;
    font-size: 16px;
  }

  .tnc2 {
    font-weight: 600;
    font-size: 18px;
  }

  .affNews-info {
    padding: 0% 3% 3% 3%;
    font-style: normal;
    font-weight: 600;
    font-size: 1rem;
    color: #000000;
  }
}

.affnews-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #fff;
  max-width: 599px;
}

.desktopNews-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #fff;
  width: 100%;
}

.imgContains {
  position: relative;
}

.ladies {
  z-index: 2;
}

.coins {
  position: absolute;
  width: 100%;
  bottom: -15%;
}

.backLight {
  position: absolute;
  width: 100%;
  bottom: -208%;
  opacity: 0.5;
}

.top-content {
  background: linear-gradient(93.88deg, #80a923 -5.4%, #517500 143.78%);
  border-bottom-right-radius: 40px;
  height: 100%;
  position: relative;
  max-width: 599px;
  @media (min-width: 959px) {
    max-width: unset !important;
    width: 100% !important;
    height: 350px !important;
    //background-image: url('/static/image/affiliate/ladies.png') !important;
  }

  .desktop-ladies {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    /* width: 200px; */
    margin-left: auto;
    margin-right: auto;
    z-index: 2;
  }

  .desktop-coins {
    position: absolute;
    width: 51%;
    bottom: -20%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-height: 435px;
  }
  .desktop-backLight {
    position: absolute;
    width: 51%;
    bottom: -20%;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
  }
}

.top-left-label {
  padding: 3% 3%;
  color: #bdff00;
}

.top-full-row-label {
  justify-content: left;
  padding: 0% 3%;
  color: #ffffff;
  font-family: 'Li-Ador-Noirrit-2';
  font-style: normal;
  font-weight: 700;
  font-size: 2.5rem;
}

@media (min-width: 300px) {
  .chip-text {
    font-size: 10px !important;
  }
}

@media (min-width: 380px) {
  .chip-text {
    font-size: 12px !important;
  }
}

@media (min-width: 500px) {
  .chip-text {
    font-size: 14px !important;
  }
}

@media (min-width: 600px) {
  .chip-text {
    font-size: 16px !important;
  }
}

@media (max-width: 400px) {
  .chip-text {
    padding: 8px 0px;
  }
  .bottom-content .contact-card .chip-text .contact-finger-icon {
    font-size: 1.3rem;
  }
  .contact-finger-icon {
    font-size: 1.3rem;
  }
  .messenger-icon {
    width: 25px;
  }
}
</style>
